// Remembers the last wizard page a draft was on, so "Continue" from the dashboard resumes
// there instead of page 1. Per browser (localStorage): a different device starts on page 1.
const STEPS = ['step1', 'step2', 'step3', 'step4', 'step5', 'step6'];
const key = (experimentId) => `registryLastStep_${experimentId}`;

export const rememberStep = (experimentId, step) => {
  try {
    localStorage.setItem(key(experimentId), step);
  } catch {
    // storage unavailable — resuming just starts on page 1
  }
};

export const lastStep = (experimentId) => {
  try {
    const step = localStorage.getItem(key(experimentId));
    return STEPS.includes(step) ? step : STEPS[0];
  } catch {
    return STEPS[0];
  }
};

export const forgetStep = (experimentId) => {
  try {
    localStorage.removeItem(key(experimentId));
  } catch {
    // nothing to clean up
  }
};
